const fda510kTheme = {
  dot: "bg-cyan-400",
  accentText: "text-cyan-200",
  subtleText: "text-cyan-300",
  tabActive: "border-cyan-400/40 bg-cyan-500/10 text-cyan-100",
  selectedRow: "border-l-2 border-cyan-400 bg-cyan-500/[0.08]",
  accentBadge: "border border-cyan-400/30 bg-cyan-500/10 text-cyan-100",
  idBadge: "border border-cyan-400/25 bg-cyan-500/5 text-cyan-100",
  detailBorder: "border-cyan-400/25",
  detailGlow: "from-cyan-400/25",
  checkbox:
    "border-cyan-300/35 text-cyan-200 hover:border-cyan-200/55 hover:bg-cyan-950/70 focus-visible:ring-cyan-300/25",
  checkboxChecked:
    "border-cyan-100/70 from-cyan-300 to-sky-400 shadow-[0_0_0_1px_rgba(186,230,253,0.16),0_10px_22px_rgba(6,182,212,0.24)]",
};

export default fda510kTheme;
